import { ADMIN_ROLE } from '../constants/OptionsConstants';
import { useInstanceContext } from '../context/useInstanceContext';

const AdminRoleRequired = ({ children }) => {

    const { instanceUserRole } = useInstanceContext();

    if (instanceUserRole.current && instanceUserRole.current.role !== ADMIN_ROLE) {
        return null
    }

    return (
        children
    )
}

export default AdminRoleRequired


